export const GET_ADMIN_ROLES = "GET_ADMIN_ROLES"
export const GET_ADMIN_ROLES_SUCCESS = "GET_ADMIN_ROLES_SUCCESS"
export const GET_ADMIN_ROLES_FAILED = "GET_ADMIN_ROLES_FAILED"

export const OPEN_ADMIN_ROLE_MODAL = "OPEN_ADMIN_ROLE_MODAL"
export const HIDE_ADMIN_ROLE_MODAL = "HIDE_ADMIN_ROLE_MODAL"

export const GET_ROLE = "GET_ROLE"
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS"
export const GET_ROLE_FAILED = "GET_ROLE_FAILED"
export const RESET_ROLE = "RESET_ROLE"

export const CREATE_ROLE = "CREATE_ROLE"
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS"
export const CREATE_ROLE_FAILED = "CREATE_ROLE_FAILED"

export const UPDATE_ROLE = "UPDATE_ROLE"
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS"
export const UPDATE_ROLE_FAILED = "UPDATE_ROLE_FAILED"

export const OPEN_DELETE_ROLE_MODAL = "OPEN_DELETE_ROLE_MODAL"
export const HIDE_DELETE_ROLE_MODAL = "HIDE_DELETE_ROLE_MODAL"
export const DELETE_ROLE = "DELETE_ROLE"
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS"
export const DELETE_ROLE_FAILED = "DELETE_ROLE_FAILED"
